import WebServiceRequest from './WebServiceRequest'

class GetAllTips extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('GET')
        super.setTag('Tips/GetAllTips')
    }
    setParams(data) {
        super.setRequestParam(data)
    }
}

class GetTipsConfig extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('GET')
        super.setTag('Tips/GetTipConfig')
    }
    setParams(data) {
        super.setRequestParamDataObj(data)
    }
}

class UpdateTipPercent extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('PUT')
        super.setTag('Tips/UpdateTipPercent')
    }
    setParams(data) {
        super.setRequestParam(data)
    }
}

export {
    GetAllTips,
    GetTipsConfig,
    UpdateTipPercent,
}
